module.exports = __webpack_public_path__ + "src/images/products/prep/43_Traveler Mock Neck Cotton Sweater.png";